import Registry from './Registry'

export { Registry }
